var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TableDropdownWrapper',_vm._b({},'TableDropdownWrapper',_vm.wrapperBinder,false),[_c('p',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.row.id))])])}
var staticRenderFns = []

export { render, staticRenderFns }